<picture class="Pic" loading="lazy"><img ref="img" loading="lazy" :width="size[0]" :height="size[1]"></picture>